export default {"src":"/_next/static/media/search.56903752.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};